import React from 'react'
import "./Why.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import w1 from "../Images/w1.svg";
import w2 from "../Images/w2.svg";
import w3 from "../Images/w3.svg";
import w4 from "../Images/w4.svg";
import w5 from "../Images/w5.svg";
import w6 from "../Images/w6.svg";
const Why = () => {
    const data = [
        {
            id: 3,
            img: w3,
            title: "Fast & Secure Web Applications",
            description: "Use Top Web Development Services India to build high-performance, secure online apps that provide a seamless user experience."
        },
        {
            id: 4,
            img: w4,
            title: "Easy-to-Use CMS Solutions",
            description: "Manage your content with ease through intuitive CMS platforms developed by experts in Custom Web Development Services."
        },
        {
            id: 5,
            img: w5,
            title: "Low-Code/No-Code Development",
            description: "Speed up your digital transformation using Web Development Services in India that offer efficient low-code/no-code solutions."
        },
        {
            id: 6,
            img: w6,
            title: "Ongoing Support & Optimization",
            description: "Ensure your digital success with continuous support and optimization from Top Web Development Services India."
        },
        {
            id: 1,
            img: w1,
            title: "Custom Website Development",
            description: "Unlock your brand's full potential with Custom Web Development Services tailored to your business needs by top web development teams in India."
        },
        {
            id: 2,
            img: w2,
            title: "Scalable E-Commerce Platforms",
            description: "Build powerful online stores with Web Development Services in India that scale effortlessly as your business grows."
        },

    ]
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        cssEase: "linear",
        transition: "all 0.5s ease-in-out",
        focusOnSelect: true,
        centerMode: true,
        // centerPadding: '5%',
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
        // centerMode: true,
        // centerPadding: '10%',
    }
    return (
        <div id='why'>
            <div className="section">
                <div className="container">
                    <h1 className="heading">
                        Why us
                    </h1>
                    <h3 className="subHeading">
                        Bastionex delivers top web development services in India—combining strategy, design, and technology to build custom, scalable, and future-ready digital solutions.
                    </h3>

                </div>
                <div className="whyInner">
                  <div className="why-inner">
                      <Slider {...settings}>
                        {data.map((item) => (
                            <div className='offerWrapper' key={item.id}>
                                <div className='offerBox'>
                                    <div className="imgBox">
                                        <img src={item.img} alt="" />
                                    </div>
                                    <h3 className="offerTitle">{item.title}</h3>
                                    <p className="offerDescription">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                  </div>
                </div>
            </div>
        </div>
    )
}

export default Why